/**
 * This component will render a nav link
 * if a child is passed it will render that as the label such a a font awesome element
 * other is it will just render the label.
 */
import React, { forwardRef } from 'react';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Spinner from '~/Components/Global/Loading/Spinner';

import RequireAuth from '~/Containers/Global/Auth/RequireAuth';
import RequireUnAuth from '~/Containers/Global/Auth/RequireUnAuth';

const NavItem = forwardRef(function NavItem(
  { auth, unAuth, label, path, children, className, onClick, onMouseLeave, isFetching },
  ref
) {
  const isExternal = path && (path.startsWith('http://') || path.startsWith('https://'));

  const renderNavLink = (path, children, label) => {
    if (isExternal) {
      return (
        <a href={path} target="_blank" rel="noopener noreferrer" onClick={(e) => {
          e.preventDefault();
          if (onClick) onClick(e);
          window.open(path, '_blank', 'noopener,noreferrer');
        }}>
          {children || label}
        </a>
      );
    }

    return path ? (
      <NavLink to={path}>{children ? children : label}</NavLink>
    ) : children ? (
      children
    ) : isFetching ? (
      <span>
        {label} <Spinner />
      </span>
    ) : (
      <span>{label}</span>
    );
  };

  const handleOnClick = e => {
    if (isExternal) return;
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  const listItem = (
    <li
      ref={ref}
      className={className}
      onMouseLeave={onMouseLeave}
      onClick={!isExternal ? handleOnClick : undefined}
    >
      {renderNavLink(path, children, label)}
    </li>
  );

  if (auth) {
    return <RequireAuth>{listItem}</RequireAuth>;
  }

  if (unAuth) {
    return <RequireUnAuth>{listItem}</RequireUnAuth>;
  }

  return listItem;
});

NavItem.propTypes = {
  auth: propTypes.bool,
  unAuth: propTypes.bool,
  label: propTypes.string,
  path: propTypes.string,
  className: propTypes.string,
  children: propTypes.node,
  onClick: propTypes.func,
  onMouseLeave: propTypes.func,
  isFetching: propTypes.bool,
};

NavItem.defaultProps = {
  onClick: () => { },
  isFetching: false,
};

export default NavItem;
